import { p } from './core.js'

// Categoria 3a — Roupeiros (R3)
// Modelos: ROUP-2P-A..F, ROUP-3P-A..F, ROUP-4P-A..F (18 modelos)
//
// Padrão R3:
//   - Maleiro superior: divisória horizontal C×P separando topo do principal
//     (altura interna 30cm, mas peça é só horizontal — não vira variável)
//   - Porta principal vai do chão ao topo (chão-topo, cobre maleiro + main)
//   - Cabideiro = ferragem (não conta MDF)
//   - Gavetas internas em altura padrão 0.20m (h_gav_comoda)
//
// Interior branco: como roupeiro tem porta fechada, TODO interior (prateleiras,
// divisória horizontal do maleiro, divisórias verticais internas, traseiras e
// laterais de gaveta) → branco. Só tampo, base, laterais externas, portas e
// frentes de gaveta seguem cor.

export const ROUPEIROS = {

  // ── ROUP-2P-A — Cabideiro + 2 Prateleiras (sem divisória vertical) ──────────
  'Roupeiro 2 Portas Cabideiro e Prateleiras': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',                  '15', v => v.P * v.A, 2),
      p('Tampo',                    '15', v => v.C * v.P, 1),
      p('Base',                     '15', v => v.C * v.P, 1),
      p('Divisória horizontal maleiro','15', v => v.C * v.P, 1, 'branco'),
      p('Prateleira',               '15', v => v.C * v.P, 2, 'branco'),
      p('Porta principal',          '15', v => (v.C/2) * v.A, 2),
      p('Fundo do móvel',           '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 8, corredica: 0, pistao: 0, rodinha: 0, cabide: 1 },
  },

  // ── ROUP-2P-B — 5 Espaços (sem maleiro, divisória vertical, prat parciais) ──
  'Roupeiro 2 Portas 5 Espaços': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',                       '15', v => v.P * v.A, 2),
      p('Divisória vertical cheia',      '15', v => v.P * v.A, 1, 'branco'),
      p('Tampo',                         '15', v => v.C * v.P, 1),
      p('Base',                          '15', v => v.C * v.P, 1),
      p('Prateleira parcial (3-prat)',   '15', v => (v.C/2) * v.P, 3, 'branco'),
      p('Prateleira parcial (1-prat)',   '15', v => (v.C/2) * v.P, 1, 'branco'),
      p('Porta',                         '15', v => (v.C/2) * v.A, 2),
      p('Fundo do móvel',                '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 8, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── ROUP-2P-C — Cabideiro + 7 Nichos ────────────────────────────────────────
  'Roupeiro 2 Portas Cabideiro e 7 Nichos': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',                       '15', v => v.P * v.A, 2),
      p('Tampo',                         '15', v => v.C * v.P, 1),
      p('Base',                          '15', v => v.C * v.P, 1),
      p('Divisória horizontal maleiro',  '15', v => v.C * v.P, 1, 'branco'),
      p('Divisória vertical (sub maleiro)','15', v => v.P * (v.A - 0.30), 1, 'branco'),
      p('Prateleira parcial (nichos)',   '15', v => (v.C/2) * v.P, 6, 'branco'),
      p('Porta principal',               '15', v => (v.C/2) * v.A, 2),
      p('Fundo do móvel',                '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 8, corredica: 0, pistao: 0, rodinha: 0, cabide: 1 },
  },

  // ── ROUP-2P-D — Cabideiro atravessando + 2 Gavetas lado a lado ──────────────
  'Roupeiro 2 Portas Cabideiro e 2 Gavetas': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',                       '15', v => v.P * v.A, 2),
      p('Tampo',                         '15', v => v.C * v.P, 1),
      p('Base',                          '15', v => v.C * v.P, 1),
      p('Divisória horizontal maleiro',  '15', v => v.C * v.P, 1, 'branco'),
      p('Divisória horizontal gavetas',  '15', v => v.C * v.P, 1, 'branco'),
      p('Porta principal',               '15', v => (v.C/2) * v.A, 2),
      p('Frente gaveta',                 '15', v => (v.C/2) * 0.20, 2),
      p('Traseira gaveta',               '15', v => (v.C/2) * 0.20, 2, 'branco'),
      p('Lateral gaveta',                '15', v => v.P * 0.20, 4, 'branco'),
      p('Fundo do móvel',                '6',  v => v.C * v.A, 1),
      p('Fundo de gaveta',               '6',  v => (v.C/2) * v.P, 2),
    ],
    ferragens: { dobradica: 8, corredica: 2, pistao: 0, rodinha: 0, cabide: 1 },
  },

  // ── ROUP-2P-E — 4 Espaços + 2 Gavetas (com divisória vertical) ──────────────
  'Roupeiro 2 Portas 4 Espaços e 2 Gavetas': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',                       '15', v => v.P * v.A, 2),
      p('Divisória vertical',            '15', v => v.P * v.A, 1, 'branco'),
      p('Tampo',                         '15', v => v.C * v.P, 1),
      p('Base',                          '15', v => v.C * v.P, 1),
      p('Prateleira coluna nichos',      '15', v => (v.C/2) * v.P, 3, 'branco'),
      p('Prateleira coluna gavetas',     '15', v => (v.C/2) * v.P, 1, 'branco'),
      p('Porta',                         '15', v => (v.C/2) * v.A, 2),
      p('Frente gaveta',                 '15', v => (v.C/2) * 0.20, 2),
      p('Traseira gaveta',               '15', v => (v.C/2) * 0.20, 2, 'branco'),
      p('Lateral gaveta',                '15', v => v.P * 0.20, 4, 'branco'),
      p('Fundo do móvel',                '6',  v => v.C * v.A, 1),
      p('Fundo de gaveta',               '6',  v => (v.C/2) * v.P, 2),
    ],
    ferragens: { dobradica: 8, corredica: 2, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── ROUP-2P-F — Maleiro + Cabideiro + 3 Gavetas (largura cheia C) ───────────
  'Roupeiro 2 Portas Cabideiro e 3 Gavetas': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',                       '15', v => v.P * v.A, 2),
      p('Tampo',                         '15', v => v.C * v.P, 1),
      p('Base',                          '15', v => v.C * v.P, 1),
      p('Divisória horizontal maleiro',  '15', v => v.C * v.P, 1, 'branco'),
      p('Divisória horizontal topo gavetas','15', v => v.C * v.P, 1, 'branco'),
      p('Porta principal',               '15', v => (v.C/2) * v.A, 2),
      p('Frente gaveta',                 '15', v => v.C * 0.20, 3),
      p('Traseira gaveta',               '15', v => v.C * 0.20, 3, 'branco'),
      p('Lateral gaveta',                '15', v => v.P * 0.20, 6, 'branco'),
      p('Fundo do móvel',                '6',  v => v.C * v.A, 1),
      p('Fundo de gaveta',               '6',  v => v.C * v.P, 3),
    ],
    ferragens: { dobradica: 8, corredica: 3, pistao: 0, rodinha: 0, cabide: 1 },
  },

}
